// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-container {
  background: #f5f5f5;
  color: #333132;
  font-family: Manrope;
  height: 80vh;
  width: 100%;
  overflow-x: hidden;
  background-color: #f5f5f5;
}

.second-container {
  align-items: center;
  width: 100%;
  height: 300px;
  border: 0.5px solid #d9d9d9;
  border-radius: 10px, 0px, 0px, 10px;
  margin-top: 12px;
}

.hover-scroll {
  overflow-y: hidden;
}

.hover-scroll:hover {
  overflow-y: scroll;
}
.checkout-item {
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.delivery-details-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tip-selection-heading {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: left;
  color: #333;
}

.tip-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tip-option {
  border: 1px solid #eeeeef;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
  border-radius: 8px;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: black;
}

.selected-tip {
  /* border-color: #28af4b; */
  border: 1px solid #28af4b;
  color: #28af4b;
}

.custom-tip-input {
  margin-top: 10px;
}

.tip-amount-other {
  border-color: #f0e68c00;
  background-color: #f5f5f500;
  border-bottom: 0.5px solid #d9d9d9;
  width: 100%;
  color: black;
  outline: none;
}

.tip-selection-para {
  font-family: Manrope;
  font-size: 14px;
  font-weight: 600;
  /* line-height: 19px; */
  letter-spacing: -0.6652777194976807px;
  text-align: left;
}

.tip-content {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.6652777194976807px;
  text-align: left;
}

.offer-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 253px;

  border-radius: 10px, 0px, 0px, 10px;
  border: 0.5px solid #d9d9d9;

  .offer-title {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 400;

    text-align: left;
  }

  .offer-btn {
    font-family: Manrope;
    font-size: 14px;
    padding-left: 12px;
    background: #ffff;
    color: #01afee;
    border: none;

    text-align: right;
  }

  .total-price {
    position: relative;
    /* top:74px */
  }

  @media (max-width: 500px) {
    .total-price {
      position: relative;
    }
  }
}

/* new */
.head-style {
  font-family: Manrope;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
}

.size {
  font-size: 16px;
}

.small-size {
  font-size: 14px;
  font-weight: 400px;
}

.medium-size {
  font-size: 15px;
  font-weight: 600px;
}

.card-container {
  border: 0.5px solid #d9d9d9;
  border-radius: 10px;
  /* padding: 12px; */
}

.color {
  color: #01afee;
}

.color-green {
  color: #28af4b;
}

.more {
  font-family: Manrope;
  font-size: 10px;
  font-weight: 600;
  line-height: 23.3px;
  letter-spacing: -0.6652777194976807px;
  text-align: left;
}

.border {
  border: none !important;
}
.checkout-scroll {
  /* width */
  ::-webkit-scrollbar {
    width: 2px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #707070;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }
}

.textarea-input {
  width: 100%;
  padding: 10px;
  font-size: 12px;
  border: none;
  box-shadow: none;
  resize: none;
  background-color: #f5f5f5;
}

.textarea-input:focus {
  outline: none;
}

.character-count {
  position: absolute;
  right: 15px;
  font-size: 10px;
  color: #888;
}
.card-custom-delverydetails {
  border-radius: 0px;
  border: none;
  background-color: transparent;
}

/* .addanother-btn {
  color: #28af4b;
}

.addanother-btn:hover {
  background-color: #28af4b;
  color: white;
} */

.border-bottom-div {
  border-bottom: 0.5px solid #d9d9d9;
}

.button-viewall-dis {
  border: none;
  outline: none;
  /* background-color: #28af4b; */
  /* color: #28af4b; */
  background-color: transparent;
  font-family: Manrope;
  font-size: 14px;
}

.address-card {
  /* width: 95% !important; */
  /* text-align: left; */
  border-color: #28af4b !important;
  overflow: hidden;
  height: 100% !important;
}

.location-custom {
  height: 24%;
}

.checkout-container {
  width: 100%;
}

.address-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.address-details h5,
.address-details p {
  margin: 0;
}

.select-address-card {
  /* width: 100% !important; */
  text-align: left;
  color: black !important;
  background-color: #28af4b !important;
  /* max-height: 150px; */
  overflow: hidden;
  height: 100% !important;
}

.confirm-address {
  color: #28af4b !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  text-decoration: underline;
  border: none;
  background-color: transparent;
  /* white-space: nowrap; */
}

.select-confirm-address {
  color: #fafafa !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  text-decoration: underline;
  border: none;
  background-color: transparent;
  white-space: nowrap;
}

.address-add-btn {
  color: #28af4b !important;
  border-color: #28af4b !important;
  align-items: center;
}

.address-card .card-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* Limit to two lines */
  -webkit-box-orient: vertical;
}

.hover-scroll {
  overflow-y: hidden;
}

.card-title {
  font-weight: 300;
}

.address-text {
  font-size: 12px;
}

/* .disable-btn {
  border: none;
  background-color: #d9d9d9;
  color: #28af4b !important;
  width: 100%;
}

.enable-btn {
  border: none !important;
  background-color: #28af4b !important;
  color: #fafafa !important;
  width: 100%;
} */

.enable-btn {
  border: 1px solid #28af4b !important;
  background-color: #fafafa !important;
  color: #28af4b !important;
  width: 100%;
  border-radius: 4px;
  min-width: 175px;
  /* height: 50px; */
}

.enable-btn:hover {
  border: 1px solid #28af4b !important;
  background-color: #28af4b !important;
  color: #fafafa !important;
  border-radius: 4px;
}

.custom-topay {
  border-top: 1px solid #d9d9d9;
}
.no-border {
  border: none;
}
.link-like {
  color: #28af4b;
  cursor: pointer;
  text-decoration: underline;
  font-size: 15px;
  font-family: Manrope;
}

.modal-fullscreen {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  background-color: rgba(0, 0, 0, 0.5);
}

.card-body-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 102px;
}

.checkout-item {
  margin-bottom: 1rem;
}

.product-price {
  font-size: 1.25rem;
  font-weight: bold;
}

.get-cart-img-div {
  min-width: 45px;
}

.get-cart-img {
  width: 40px;
  height: 41px;
  aspect-ratio: 4/2;
  border-radius: 4px;
}

.cart-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  /* padding: 5px; */
}

.cart-counter {
  /* padding: 8px 12px; */
  min-width: 30px;
  cursor: pointer;
  color: #707070;
  transition: background-color 0.3s ease, transform 0.3s ease;
  text-align: center;
}

.cart-counter:hover {
  background-color: #e2e6ea;
  transform: scale(1.05);
}

.cart-counter:first-of-type {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.cart-counter:last-of-type {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.product-weight {
  font-size: 0.9rem;
  color: gray;
}
.product-count {
  font-size: 12px;
  color: #707070;
  border-left: 1px solid #28af4b;
  border-right: 1px solid #28af4b;
  min-width: 30px;
  text-align: center;
}

.cart-counter-button:active {
  transform: scale(0.95);
}

.add-new-item {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  cursor: pointer;
  /* padding: 0.5rem 1rem; */
  /* margin-top: 1rem; */
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}

.add-new-item-text {
  font-family: Manrope;
  font-size: 1.25rem;
  font-weight: 400;
  color: #333132;
}

.add-new-item-icon {
  font-size: 1.5rem;
  font-weight: 1000;
  color: #28af4b;
  text-align: right;
}
.add-new-item-icon:hover {
  transform: scale(1.02);
  transition: background-color 0.3s, transform 0.2s;
}

.add-new-item:active {
  transform: scale(0.98);
}

@keyframes increment-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 760px) {
  .confirm-address {
    font-size: 20px !important;
    /* Adjust the font size for smaller screens */
  }

  .address-add-btn {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.address-add-btn {
  font-size: 10px;
}

.card-button-Coupon {
  width: 100%;
  height: 38px;
  border-radius: 5px;
  border: none;
  background-color: #333132;
  color: white;
  font-family: Manrope;
}

.modal-address-custom {
  max-width: 800px;
}
.card-custom-address {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/deliveryDetails/DelveryDetails.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;;EAEb,mCAAmC;EACnC,2BAA2B;;EAE3B;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;;IAEhB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,YAAY;;IAEZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA,QAAQ;AACR;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV;IACE,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;;;;;;GAOG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6CAA6C;EAC/C;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd","sourcesContent":[".body-container {\n  background: #f5f5f5;\n  color: #333132;\n  font-family: Manrope;\n  height: 80vh;\n  width: 100%;\n  overflow-x: hidden;\n  background-color: #f5f5f5;\n}\n\n.second-container {\n  align-items: center;\n  width: 100%;\n  height: 300px;\n  border: 0.5px solid #d9d9d9;\n  border-radius: 10px, 0px, 0px, 10px;\n  margin-top: 12px;\n}\n\n.hover-scroll {\n  overflow-y: hidden;\n}\n\n.hover-scroll:hover {\n  overflow-y: scroll;\n}\n.checkout-item {\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n\n.delivery-details-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.tip-selection-heading {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  text-align: left;\n  color: #333;\n}\n\n.tip-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.tip-option {\n  border: 1px solid #eeeeef;\n  padding: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n  cursor: pointer;\n  border-radius: 8px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  color: black;\n}\n\n.selected-tip {\n  /* border-color: #28af4b; */\n  border: 1px solid #28af4b;\n  color: #28af4b;\n}\n\n.custom-tip-input {\n  margin-top: 10px;\n}\n\n.tip-amount-other {\n  border-color: #f0e68c00;\n  background-color: #f5f5f500;\n  border-bottom: 0.5px solid #d9d9d9;\n  width: 100%;\n  color: black;\n  outline: none;\n}\n\n.tip-selection-para {\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 600;\n  /* line-height: 19px; */\n  letter-spacing: -0.6652777194976807px;\n  text-align: left;\n}\n\n.tip-content {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: -0.6652777194976807px;\n  text-align: left;\n}\n\n.offer-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 253px;\n\n  border-radius: 10px, 0px, 0px, 10px;\n  border: 0.5px solid #d9d9d9;\n\n  .offer-title {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 400;\n\n    text-align: left;\n  }\n\n  .offer-btn {\n    font-family: Manrope;\n    font-size: 14px;\n    padding-left: 12px;\n    background: #ffff;\n    color: #01afee;\n    border: none;\n\n    text-align: right;\n  }\n\n  .total-price {\n    position: relative;\n    /* top:74px */\n  }\n\n  @media (max-width: 500px) {\n    .total-price {\n      position: relative;\n    }\n  }\n}\n\n/* new */\n.head-style {\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 16px;\n}\n\n.size {\n  font-size: 16px;\n}\n\n.small-size {\n  font-size: 14px;\n  font-weight: 400px;\n}\n\n.medium-size {\n  font-size: 15px;\n  font-weight: 600px;\n}\n\n.card-container {\n  border: 0.5px solid #d9d9d9;\n  border-radius: 10px;\n  /* padding: 12px; */\n}\n\n.color {\n  color: #01afee;\n}\n\n.color-green {\n  color: #28af4b;\n}\n\n.more {\n  font-family: Manrope;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 23.3px;\n  letter-spacing: -0.6652777194976807px;\n  text-align: left;\n}\n\n.border {\n  border: none !important;\n}\n.checkout-scroll {\n  /* width */\n  ::-webkit-scrollbar {\n    width: 2px;\n  }\n\n  /* Track */\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 10px;\n  }\n\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #707070;\n    border-radius: 10px;\n  }\n\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #707070;\n  }\n}\n\n.textarea-input {\n  width: 100%;\n  padding: 10px;\n  font-size: 12px;\n  border: none;\n  box-shadow: none;\n  resize: none;\n  background-color: #f5f5f5;\n}\n\n.textarea-input:focus {\n  outline: none;\n}\n\n.character-count {\n  position: absolute;\n  right: 15px;\n  font-size: 10px;\n  color: #888;\n}\n.card-custom-delverydetails {\n  border-radius: 0px;\n  border: none;\n  background-color: transparent;\n}\n\n/* .addanother-btn {\n  color: #28af4b;\n}\n\n.addanother-btn:hover {\n  background-color: #28af4b;\n  color: white;\n} */\n\n.border-bottom-div {\n  border-bottom: 0.5px solid #d9d9d9;\n}\n\n.button-viewall-dis {\n  border: none;\n  outline: none;\n  /* background-color: #28af4b; */\n  /* color: #28af4b; */\n  background-color: transparent;\n  font-family: Manrope;\n  font-size: 14px;\n}\n\n.address-card {\n  /* width: 95% !important; */\n  /* text-align: left; */\n  border-color: #28af4b !important;\n  overflow: hidden;\n  height: 100% !important;\n}\n\n.location-custom {\n  height: 24%;\n}\n\n.checkout-container {\n  width: 100%;\n}\n\n.address-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.address-details h5,\n.address-details p {\n  margin: 0;\n}\n\n.select-address-card {\n  /* width: 100% !important; */\n  text-align: left;\n  color: black !important;\n  background-color: #28af4b !important;\n  /* max-height: 150px; */\n  overflow: hidden;\n  height: 100% !important;\n}\n\n.confirm-address {\n  color: #28af4b !important;\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  text-decoration: underline;\n  border: none;\n  background-color: transparent;\n  /* white-space: nowrap; */\n}\n\n.select-confirm-address {\n  color: #fafafa !important;\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  text-decoration: underline;\n  border: none;\n  background-color: transparent;\n  white-space: nowrap;\n}\n\n.address-add-btn {\n  color: #28af4b !important;\n  border-color: #28af4b !important;\n  align-items: center;\n}\n\n.address-card .card-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  /* Limit to two lines */\n  -webkit-box-orient: vertical;\n}\n\n.hover-scroll {\n  overflow-y: hidden;\n}\n\n.card-title {\n  font-weight: 300;\n}\n\n.address-text {\n  font-size: 12px;\n}\n\n/* .disable-btn {\n  border: none;\n  background-color: #d9d9d9;\n  color: #28af4b !important;\n  width: 100%;\n}\n\n.enable-btn {\n  border: none !important;\n  background-color: #28af4b !important;\n  color: #fafafa !important;\n  width: 100%;\n} */\n\n.enable-btn {\n  border: 1px solid #28af4b !important;\n  background-color: #fafafa !important;\n  color: #28af4b !important;\n  width: 100%;\n  border-radius: 4px;\n  min-width: 175px;\n  /* height: 50px; */\n}\n\n.enable-btn:hover {\n  border: 1px solid #28af4b !important;\n  background-color: #28af4b !important;\n  color: #fafafa !important;\n  border-radius: 4px;\n}\n\n.custom-topay {\n  border-top: 1px solid #d9d9d9;\n}\n.no-border {\n  border: none;\n}\n.link-like {\n  color: #28af4b;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 15px;\n  font-family: Manrope;\n}\n\n.modal-fullscreen {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1050;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.card-body-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 102px;\n}\n\n.checkout-item {\n  margin-bottom: 1rem;\n}\n\n.product-price {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.get-cart-img-div {\n  min-width: 45px;\n}\n\n.get-cart-img {\n  width: 40px;\n  height: 41px;\n  aspect-ratio: 4/2;\n  border-radius: 4px;\n}\n\n.cart-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  /* padding: 5px; */\n}\n\n.cart-counter {\n  /* padding: 8px 12px; */\n  min-width: 30px;\n  cursor: pointer;\n  color: #707070;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  text-align: center;\n}\n\n.cart-counter:hover {\n  background-color: #e2e6ea;\n  transform: scale(1.05);\n}\n\n.cart-counter:first-of-type {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.cart-counter:last-of-type {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.product-weight {\n  font-size: 0.9rem;\n  color: gray;\n}\n.product-count {\n  font-size: 12px;\n  color: #707070;\n  border-left: 1px solid #28af4b;\n  border-right: 1px solid #28af4b;\n  min-width: 30px;\n  text-align: center;\n}\n\n.cart-counter-button:active {\n  transform: scale(0.95);\n}\n\n.add-new-item {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  cursor: pointer;\n  /* padding: 0.5rem 1rem; */\n  /* margin-top: 1rem; */\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.add-new-item-text {\n  font-family: Manrope;\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: #333132;\n}\n\n.add-new-item-icon {\n  font-size: 1.5rem;\n  font-weight: 1000;\n  color: #28af4b;\n  text-align: right;\n}\n.add-new-item-icon:hover {\n  transform: scale(1.02);\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.add-new-item:active {\n  transform: scale(0.98);\n}\n\n@keyframes increment-animation {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 760px) {\n  .confirm-address {\n    font-size: 20px !important;\n    /* Adjust the font size for smaller screens */\n  }\n\n  .address-add-btn {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.address-add-btn {\n  font-size: 10px;\n}\n\n.card-button-Coupon {\n  width: 100%;\n  height: 38px;\n  border-radius: 5px;\n  border: none;\n  background-color: #333132;\n  color: white;\n  font-family: Manrope;\n}\n\n.modal-address-custom {\n  max-width: 800px;\n}\n.card-custom-address {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
